import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledRelatedArticlesContainer = styled.div<{
  category: string;
}>`
  .text-center-card-vertical {
    text-align: left !important;
    max-width: 100% !important;
    .m-ellipsis-2lines {
      -webkit-line-clamp: 4;
    }
  }

  .text-center-card-vertical::before {
    content: '${props => props?.category}';
    text-transform: uppercase;
    letter-spacing: ${toRem(1.2)};
    font: normal normal 700 ${toRem(12)} / ${toRem(12)} var(--t-base-font-family);
    color: var(--t-brand-alt-color);
    margin-bottom: ${toRem(8)};
  }

  .card-vertical {
    img {
      aspect-ratio: 16/9;
    }
  }
`;
